<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/germany/baden')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/germany/baden/bernhard-huber')">Bernhard Huber
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/germany/baden')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Bernhard Huber</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Soprannominato il padrino del Pinot Nero tedesco, l'omonimo vino di Bernhard Huber è riconosciuto tra i migliori della Germania. In parte responsabile della rivoluzione vinicola tedesca, è considerato tra i primi dieci produttori tedeschi e sicuramente il primo produttore di Pinot in Germania. È persino apparso nella guida gastronomica francese Gault et Millau come il miglior produttore del 2007, e tendono a sapere una o due cose sul vino.
                    </div>

                    <div class="howto-title2">Un vino tedesco à la Française</div>
                    <div class="howto-text">
                        La tenuta si trova su un terroir privilegiato, molto simile al terreno ricco di minerali della Borgogna. Così è stato
                        nessuna sorpresa di trovare il Pinot Nero in crescita; infatti, i registri mostrano che le viti crescevano fino a
                        700 anni fa e "Malterdinger", dove si trova la tenuta, è un'altra parola per Pinot Noir.
                        Sebbene il vigneto appartenesse alla famiglia Huber da diverse generazioni, non è stato fino a quando
                        Bernhard e sua moglie Barbara hanno iniziato a gestire la tenuta nel 1987 che hanno iniziato a imbottigliare
                        il proprio nome. Insieme hanno coltivato la tenuta di 26 ettari, il 65% dei quali è Pinot Noir (o
                        Spatburgunder in tedesco). Huber ha deciso di coltivare in modo biologico, oltre a limitare i raccolti da aggiungere
                        strati di concentrazione. Nel 2004 esce il suo primo “Riserva”, un vino da vigneto singolo che
                        è stato riconosciuto come uno dei migliori della Germania.
                    </div>

                    <div class="howto-title2">Una triste perdita</div>
                    <div class="howto-text">
                        Purtroppo, Bernhard ha perso la sua battaglia contro il cancro a soli 55 anni nel 2014. La sua eredità, tuttavia, sopravvive;
                        suo figlio, Julien, ha preso le redini della tenuta e col passare del tempo, è chiaro che il suo
                        padre gli ha insegnato bene. Ha mantenuto l'intera squadra che ha lavorato sotto la tutela di suo padre e
                        ha introdotto alcuni piccoli (ma significativi) cambiamenti nella gestione quotidiana del
                        Attività commerciale. I vini di Julien (a prezzi molto ragionevoli) hanno un punteggio elevato, con un punteggio medio-alto
                        bassi anni novanta quasi costantemente. La domanda di mercato è leggermente diminuita tra il 2017 e il 2019, ma i prezzi sì
                        rimasto stabile.
                    </div>

                    <div class="howto-title2">Fatti e annate notevoli</div>
                    <div class="howto-text">
                        <ul>
                            <li>Nonostante le sfide presentate nella stagione di crescita del 2017, i rendimenti inferiori equivalgono a
                                alta qualità nel caso del Baden Chardonnay Bienenberg GG 2016 di Bernhard Huber. Vino
                                Alex Zecevic di Spectator ha notato che questo era “un altro stupefacente, che ricorda gli Chardonnay
                                dalla regione francese del Giura, che mostra un'acidità prominente con sapori di erbe e minerali
                                carattere." Sta aumentando l'interesse sopra la media, secondo wine-searcher e prezzi
                                sono anche in aumento - quasi +19% tra maggio 2017 e aprile 2019.
                            </li>
                            <li>Bernhard Huber 'R' Wildenstein Spatburgunder Trocken ottiene alcuni dei critici più alti
                                punteggi e prezzi a Baden. Stephen Tanzer ha valutato l'annata 2011 con 95 punti, il
                                prezzo delle quantità esigue in aumento del +38% nel periodo maggio 2017-aprile 2019.
                            </li>
                            <li>Quasi impossibile da trovare, il Malterdinger Bienenberg Wildenstein Spätburgunder GG del 2012
                                ha ricevuto 19/20 da Jancis Robinson, così come il Bombacher Sommerhalde Spätburgunder del 2011
                                GG.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Bernhard Huber</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Der gleichnamige Wein von Bernhard Huber, der den Spitznamen „Godfather des deutschen Pinot Noir“ trägt, gilt als einer der besten Deutschlands. Er ist mitverantwortlich für die deutsche Weinrevolution und gilt als einer der zehn besten Produzenten Deutschlands und sicherlich als der beste Pinot-Produzent in Deutschland. Er tauchte sogar im französischen Gastronomieführer Gault et Millau als Spitzenproduzent des Jahres 2007 auf, und sie wissen in der Regel ein oder zwei Dinge über Wein.
                    </div>

                    <div class="howto-title2">Ein deutscher Wein à la Française</div>
                    <div class="howto-text">
                        Das Anwesen liegt auf einem erstklassigen Terroir, das dem mineralreichen Boden Burgunds sehr ähnlich ist. So war es
                        Es ist keine Überraschung, dass Pinot Noir wächst. Tatsächlich zeigen Aufzeichnungen, dass es so viele Weinreben gab
                        Vor 700 Jahren und „Malterdinger“, wo das Weingut liegt, ist ein anderes Wort für Pinot Noir.
                        Obwohl das Weingut schon seit mehreren Generationen im Besitz der Familie Huber war, wurde es erst später
                        Bernhard und seine Frau Barbara übernahmen 1987 die Leitung des Weinguts und begannen mit der Abfüllung
                        ihren eigenen Namen. Gemeinsam bauten sie das Anwesen auf einer Fläche von 26 Hektar an, wovon 65 % Pinot Noir (bzw. Pinot Noir) sind
                        Spatburgunder auf Deutsch). Huber entschied sich für den ökologischen Landbau und begrenzte die Erträge
                        Schichten der Konzentration. Im Jahr 2004 brachte er seinen ersten „Reserve“ heraus, einen Einzellagenwein
                        gilt mittlerweile als einer der besten Deutschlands.
                    </div>

                    <div class="howto-title2">Ein trauriger Verlust</div>
                    <div class="howto-text">
                        Leider verlor Bernhard 2014 im Alter von nur 55 Jahren seinen Kampf gegen den Krebs. Sein Erbe lebt jedoch weiter;
                        Sein Sohn Julien hat die Leitung des Anwesens übernommen und im Laufe der Zeit wird klar, dass es ihm gehört
                        Vater hat ihn gut unterrichtet. Er hat das gesamte Team, das unter der Anleitung seines Vaters gearbeitet hat, behalten
                        hat ein paar kleine (aber bedeutende) Änderungen in den täglichen Betrieb des eingeführt
                        Geschäft. Die (sehr preisgünstigen) Weine von Julien werden hoch bewertet und liegen im mittleren bis mittleren Bereich
                        fast durchgängig niedrige Neunziger. Die Marktnachfrage ist zwischen 2017 und 2019 leicht zurückgegangen, die Preise jedoch
                        blieb stabil.
                    </div>

                    <div class="howto-title2">Bemerkenswerte Fakten und Jahrgänge</div>
                    <div class="howto-text">
                        <ul>
                            <li>Trotz der Herausforderungen in der Vegetationsperiode 2017 sind geringere Erträge gleichbedeutend mit
                                hohe Qualität im Falle des Baden Chardonnay Bienenberg GG 2016 von Bernhard Huber. Wein
                                Alex Zecevic von Spectator bemerkte, dass dies „ein weiterer Hingucker war, der an Chardonnays erinnert.“
                                aus der französischen Jura-Region, mit ausgeprägter Säure, würzigen Kräuter- und Mineralnoten
                                Charakter." Laut Wein-Sucher und Preisen steigt das Interesse überdurchschnittlich
                                sind ebenfalls auf dem Vormarsch – fast +19 % zwischen Mai 2017 und April 2019.
                            </li>
                            <li>Bernhard Huber „R“ Wildenstein Spatburgunder Trocken erntet einige der höchsten Kritiken
                                Partituren und Preise in Baden. Stephen Tanzer bewertete den Jahrgang 2011 mit 95 Punkten
                                Preis für knappe Mengen steigt im Zeitraum Mai 2017 bis April 2019 um +38 %.
                            </li>
                            <li>Fast unmöglich zu finden, den 2012 Malterdinger Bienenberg Wildenstein Spätburgunder GG
                                erhielt 19/20 von Jancis Robinson, ebenso wie der Bombacher Sommerhalde Spätburgunder 2011
                                GG.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Bernhard Huber</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Surnommé le parrain du pinot noir allemand, le vin éponyme de Bernhard Huber est reconnu parmi les meilleurs d'Allemagne. Partiellement responsable de la révolution viticole allemande, il est considéré comme l'un des dix premiers producteurs allemands et certainement le premier producteur de pinot en Allemagne. Il est même apparu dans le guide gastronomique français Gault et Millau en tant que meilleur producteur de 2007, et ils ont tendance à en savoir une chose ou deux sur le vin.
                    </div>

                    <div class="howto-title2">Un vin allemand à la française</div>
                    <div class="howto-text">
                        Le domaine est sur un terroir de premier choix, très similaire au sol riche en minéraux de la Bourgogne. Ainsi c'était
                        pas de surprise de voir pousser du Pinot Noir ; en fait, les archives montrent que les vignes poussaient jusqu'à
                        Il y a 700 ans et "Malterdinger", où se trouve le domaine, est un autre mot pour Pinot Noir.
                        Si le vignoble appartenait à la famille Huber depuis plusieurs générations, ce n'est que
                        Bernhard et sa femme Barbara ont pris la direction du domaine en 1987 qu'ils ont commencé à embouteiller sous
                        leur propre nom. Ensemble, ils cultivent le domaine de 26 hectares dont 65% de Pinot Noir (ou
                        Spatburgunder en allemand). Huber a décidé de cultiver biologiquement, ainsi que de limiter les rendements pour ajouter
                        couches de concentration. En 2004, il sort sa première "Réserve", un vin de vignoble unique qui
                        est devenu l'un des meilleurs d'Allemagne.
                    </div>

                    <div class="howto-title2">Une triste perte</div>
                    <div class="howto-text">
                        Malheureusement, Bernhard a perdu sa bataille contre le cancer à seulement 55 ans en 2014. Son héritage, cependant, perdure ;
                        son fils, Julien, a repris les rênes du domaine et au fil du temps, force est de constater que son
                        père lui a bien appris. Il a gardé toute l'équipe qui travaillait sous la tutelle de son père et
                        a introduit quelques changements mineurs (mais significatifs) dans le fonctionnement quotidien du
                        entreprise. Les vins de Julien (à un prix très raisonnable) se classent très bien, se situant entre
                        bas des années 90 presque systématiquement. La demande du marché a légèrement diminué entre 2017 et 2019, mais les prix ont
                        est resté stable.
                    </div>

                    <div class="howto-title2">Faits marquants et millésimes</div>
                    <div class="howto-text">
                        <ul>
                            <li>Malgré les difficultés rencontrées au cours de la saison de croissance 2017, des rendements plus faibles correspondent à
                                de haute qualité dans le cas du Baden Chardonnay Bienenberg GG 2016 de Bernhard Huber. Vin
                                Alex Zecevic du spectateur a noté que c'était "un autre étourdissant, qui rappelle les chardonnays
                                de la région du Jura français, affichant une acidité proéminente avec des herbes et des minéraux savoureux
                                personnage." L'intérêt supérieur à la moyenne augmente, selon le chercheur de vin et les prix
                                sont également en hausse - près de +19% entre mai 2017 et avril 2019.
                            </li>
                            <li>Bernhard Huber 'R' Wildenstein Spatburgunder Trocken obtient certains des plus grands critiques
                                notes et prix à Baden. Stephen Tanzer a noté le millésime 2011 avec 95 points, le
                                prix des petites quantités en hausse +38% sur la période de mai 2017 à avril 2019.
                            </li>
                            <li>Presque introuvable, le Malterdinger Bienenberg Wildenstein Spätburgunder GG 2012
                                reçu 19/20 de Jancis Robinson, tout comme 2011 Bombacher Sommerhalde Spätburgunder
                                GG.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Bernhard Huber</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Nicknamed the Godfather of German Pinot Noir, Bernhard Huber’s eponymous wine is recognised among Germany’s best. Partly responsible for the German wine revolution, he is considered among Germany’s top ten producers, and certainly the top Pinot producer in Germany. He even popped up in French gastronomic guide Gault et Millau as the top producer of 2007, and they tend to know a thing or two about wine.
                    </div>

                    <div class="howto-title2">A German wine à la Française</div>
                    <div class="howto-text">
                        The estate is on prime terroir, very similar to the mineral-rich soil of Burgundy. Thus it was
                        no surprise to find Pinot Noir growing; in fact, records show that vines were growing as many as
                        700 years ago and “Malterdinger”, where the estate is located, is another word for Pinot Noir.
                        Although the vineyard had been in the Huber family for several generations, it wasn’t until
                        Bernhard and his wife Barbara took to running the estate in 1987 that they began bottling under
                        their own name. Together they grew the estate the 26-hectares, 65% of which is Pinot Noir (or
                        Spatburgunder in German). Huber decided to farm organically, as well as limit yields to add
                        layers of concentration. In 2004 he released his first “Reserve”, a single vineyard wine that
                        has come be recognised as one of Germany’s bests.
                    </div>

                    <div class="howto-title2">A sad loss</div>
                    <div class="howto-text">
                        Sadly, Bernhard lost his battle with cancer aged just 55 in 2014. His legacy, however, lives on;
                        his son, Julien, has taken up the reins of the estate and as time goes on, it is clear that his
                        father taught him well. He has kept the entire team that worked under his father’s tutelage and
                        has introduced a few small (but significant) changes into the day to day running of the
                        business. Julien’s (very reasonably priced) wines rate highly, scoring in the mid to
                        low-nineties almost consistently. Market demand fell slightly between 2017-2019, but prices have
                        remained stable.
                    </div>

                    <div class="howto-title2">Notable facts and vintages</div>
                    <div class="howto-text">
                        <ul>
                            <li>Despite the challenges presented in 2017’s growing season, smaller yields equate with
                                high quality in the case of Bernhard Huber’s Baden Chardonnay Bienenberg GG 2016. Wine
                                Spectator’s Alex Zecevic noted this was “another stunner, reminiscent of Chardonnays
                                from France’s Jura region, displaying prominent acidity with savoury herbal and mineral
                                character.” Above average interest is increasing, according to wine-searcher and prices
                                are also on the rise - nearly +19% between May 2017 and April 2019.
                            </li>
                            <li>Bernhard Huber 'R' Wildenstein Spatburgunder Trocken fetches some of the highest critic
                                scores and prices in Baden. Stephen Tanzer rated the 2011 vintage with 95 points, the
                                price of scant quantities on the rise +38% over the period of May 2017 to April 2019.
                            </li>
                            <li>Near impossible to find, the 2012 Malterdinger Bienenberg Wildenstein Spätburgunder GG
                                received 19/20 from Jancis Robinson, as did 2011 Bombacher Sommerhalde Spätburgunder
                                GG.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BernhardHuber",
    data() {
        return {
            select: {report: 'Bernhard Huber', src: '/wine-guide/germany/baden/bernhard-huber'},
            items: [
                {report: 'Bernhard Huber', src: '/wine-guide/germany/baden/bernhard-huber'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Bernhard Huber | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional wine creations of Bernhard Huber, a leading wine producer in the Baden region. Explore the rich taste and aroma of their premium quality red and white wines, expertly crafted to perfection. Experience the finest wine tasting experience with Bernhard Huber.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
